<template>
    <div class="orderDetail print">
        <el-card class="noprint">
            <el-page-header v-if="child.from == 'settlement'" @back="goBack" :content="'结算单号('+ child.settlementNo + ')'"></el-page-header>
            <el-breadcrumb v-if="from == 'menu'" separator="/">
                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>结算管理</el-breadcrumb-item>
                <el-breadcrumb-item>结算单详情</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <main class="content">
            <div style="text-align: right;padding-bottom: 10px" class="noprint">

                <el-button size="min"  @click="printOrder" type="primary">打印</el-button>
            </div>
            <div class="quote mt20 mb60 pt10">
                <div class="clearfix" >
                    <div class="fl" style="font-size: 14px;float: left;font-weight: bold;line-height: 20px;">
                            <div><span>结算单号：</span><span >{{child.settlementNo}}</span></div>
                            <div><span>创建时间：</span><span >{{child.createTime}}</span></div>
                            <div><a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a></div>
                        </div>
                        <div class="fr" style="text-align: right"><img src="../../assets/logo3.png" alt="" width="300"/></div>
                    </div>
                    <div style="width:100%;" >
                        <div>
                            <table style="width: 500px !important;float:right;margin-right: 0 !important;" border="1">
                                <tr style="width: 500px;" >
                                    <th colspan="2" style="padding: 3px; background: #dfdfdf">结算单</th>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 120px;">客户编号：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{child == null ? '-':child.code}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 100px;">客户名称：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{child == null ? '-':child.companyName}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;width: 90px;">结算单号：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{child.settlementNo}}</td>
                                </tr>
                                <tr style="width: 500px;">
                                    <td style="padding: 3px;">开票金额：</td>
                                    <td style="padding: 3px;min-width: 300px;">{{'￥'+child.totalPrice+'元'}}</td>
                                </tr>

                            </table>
                            <div style="clear: both"></div>
                        </div>
                    </div>

                <div style="margin: 16px 0;clear: both;"><span style="font-size: 16px">订单进度查询：合同生效后，甲方及其采购人员可以通过鹏龙天创MRO平台(<a href="https://mro.tcmtc.com.cn/" style="color:#000">https://mro.tcmtc.com.cn</a>)查看订单处理进度，如有疑问或问题请联系为您服务的客服。</span></div>
                <div style="margin-top: 16px;"><span>1. 订单信息</span></div>
                <div style="margin-top: 3px;">
                    <template v-for="one in allData">
                        <div v-bind:key="one.name+'_d'" style="clear: both;margin-top: 10px;">
                            <div   style="margin-top: 16px;"><span >订单编号：{{one.name}}</span></div>

                            <table border="1" style="table-layout: fixed; width: 100%">
                                <tr style="width: 100%;background: #dfdfdf;">
                                    <th style="width: 60px">序号</th>
                                    <th style="width: 120px">商品编码</th>
                                    <th  style="width: 150px">产品名称</th>
                                    <th style="width: 130px">品牌</th>
                                    <th style="width: 130px">规格型号</th>
                                    <th style="width: 90px">数量</th>
                                    <th style="width: 120px">未税单价</th>
                                    <th style="width: 120px">含税单价</th>
                                    <th style="width: 120px">未税总价</th>
                                    <th style="width: 120px">含税总价</th>
                                </tr>
                                <template v-for="(item,i) in one.data">
                                    <tr style="width: 100%" v-bind:key="item.id+'_d'">
                                        <td align="center" style="padding: 0 5px; width: 50px;">{{i+1}}</td>
                                        <td align="center" style="padding: 0 5px; width: 110px" >{{item.sku}}</td>
                                        <td align="left"  style="padding: 0 5px; width: 200px" >{{item.name}}</td>
                                        <td align="center"  style="padding: 0 5px;width: 120px">{{item.brand}}</td>
                                        <td align="center"  style="padding: 0 5px;width: 120px">{{item.model}}</td>
                                        <td align="center"   style="padding: 0 5px;" >{{item.unit === null ? item.num+'件' : item.num+item.unit}}</td>
                                        <td align="center"   style="padding: 0 5px;">{{'￥'+item.untaxedPrice+'元'}}</td>
                                        <td align="center" style="padding: 0 5px;" >{{'￥'+item.price+'元'}}</td>
                                        <td align="center"  style="padding: 0 5px;" >{{'￥'+item.totalUntaxedPrice+'元'}}</td>
                                        <td align="center"  style="padding: 0 5px;">{{'￥'+item.totalPrice+'元'}}</td>
                                    </tr>
                                </template>
                                <tr style="width: 100%">
                                    <th colspan="2"  style="width: 181px;background: #dfdfdf;">商品未税总价(CNY)：</th>
                                    <td colspan="8" style="padding: 0 5px;">{{"￥"+one.totalUntaxedPrice+"元"}}</td>
                                </tr>
                                <tr style="width: 100%">
                                    <th colspan="2" style="width: 181px;background: #dfdfdf;">商品含税总价(CNY)：</th>
                                    <td colspan="8" style="padding: 0 5px;" >{{"￥"+one.totalPrice+"元"}}</td>
                                </tr>
                            </table>


                        </div>
                    </template>
                </div>
                <div><span>说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>
                <div style="margin-top: 16px;"><span>2. 开票资料信息</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%">
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">公司名称：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.companyName}}</td>
                            <th  colspan="2" style="width: 185px;background: #dfdfdf;">发票类型：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.showType}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">开户银行：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.bankName}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">注册电话：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.companyTaxNo}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">银行账号：</th>
                            <td colspan="3" style="padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.bankAccount}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">注册地址：</th>
                            <td colspan="3" style="padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.registeredAddress}}</td>

                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">公司税号：</th>
                            <td colspan="3" style="width: 367px;padding: 0 5px;">{{infoData.invoice == null ? '-':infoData.invoice.bankAccount}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">备注信息：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">-</td>

                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;"><span>3. 邮寄信息</span></div>
                <div style="margin-top: 3px;">

                    <table border="1" style="table-layout: fixed; width: 100%">
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">邮寄地址：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.address.province+infoData.address.city +infoData.address.county + infoData.address.address}}</td>
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">详细地址：</th>
                            <td colspan="3" style="width: 467px;padding: 0 5px;">{{infoData.address.address}}</td>
                        </tr>
                        <tr style="width: 100%">
                            <th colspan="2" style="width: 185px;background: #dfdfdf;">收件人：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{infoData.address.consignee}}</td>
                            <th  colspan="2" style="width: 185px;background: #dfdfdf;">联系电话：</th>
                            <td  colspan="3" style="padding: 0 5px;">{{infoData.address.mobile}}</td>

                        </tr>
                    </table>
                </div>
                <div style="margin-top: 16px;">
                    <div>备注：</div>
                    <div>1.在中华人民共和国境内，对于净值超过人民币300元的订单我们提供免费寄送服务。对于订货金额低于人民币300元的订单，我们将收取每单40元的送货费。</div>
                    <div>2.对于错订的物品，我们将收取10%的退货费，最少100元起。</div>
                    <div>3.货物运输至中国境内客户指定地点。</div>
                    <div>4.新疆、西藏、青海等偏远地区的最小订单金额、运费及货期以实际报价阶段为准。</div>
                </div>


<!--                    <div style="width:100%;clear: both;" >-->
<!--                        <div style="clear: both;">-->

<!--                            <el-table style="font-size: 14px;float:right;margin-right: 0 !important;"-->
<!--                                      v-loading="loading1" border-->
<!--                                      :data="orderData" class="tableBaseInfo el-table-order"-->
<!--                                      size="mini" :header-cell-style="tableHeaderColor" :cell-style="columnStyleO"-->
<!--                                      :header-row-class-name="hiddenHeaderRow" >-->
<!--                                <el-table-column label="结算单" align="center" >-->
<!--                                    <el-table-column prop="name" align="center" width="150px"></el-table-column>-->
<!--                                    <el-table-column prop="nameValue" align="left" ></el-table-column>-->
<!--                                </el-table-column>-->
<!--                            </el-table>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div style="clear: both;margin-top: 5px;">-->
<!--                      <div style="margin-top: 16px;"><span style="font-size: 12px">1. 订单信息</span></div>-->
<!--                    </div>-->

<!--                    <div>-->
<!--                        <template v-for="item in allData">-->
<!--                            <div v-bind:key="item.name+'_d'" style="clear: both;margin-top: 10px;">-->
<!--                                <div   style="margin-top: 16px;"><span style="font-size: 12px">订单编号：{{item.name}}</span></div>-->
<!--                            </div>-->
<!--                            <el-table-->
<!--                                    v-bind:key="item.name"-->
<!--                                    :data="item.data"-->
<!--                                    v-loading="loading"-->
<!--                                    :header-cell-style="tableHeaderColor" border-->
<!--                                    class="tableBaseInfo el-table-o" :cell-style="columnStyleO"-->
<!--                                    style="width: 100%;border-bottom: none !important;">-->
<!--                                <el-table-column type="index" label="序号" width="40"/>-->
<!--                                <el-table-column prop="sku" label="商品编码" width="120"/>-->
<!--                                <el-table-column prop="name" label="产品名称" />-->
<!--                                <el-table-column prop="brand" label="品牌" width="100" align="center"/>-->
<!--                                <el-table-column prop="model" label="规格型号" width="100" align="center"/>-->
<!--                                <el-table-column prop="num" label="数量" width="80" align="center">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{scope.row.unit === null ? scope.row.num+'件' : scope.row.num+scope.row.unit}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->

<!--                                <el-table-column-->
<!--                                        prop="untaxedPrice"-->
<!--                                        label="未税单价(元)"-->
<!--                                        width="120"-->
<!--                                        align="center">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{'￥'+scope.row.untaxedPrice+'元'}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column-->
<!--                                        prop="price"-->
<!--                                        label="含税单价(元)"-->
<!--                                        width="120"-->
<!--                                        align="center">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{'￥'+scope.row.price+'元'}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column-->
<!--                                        prop="totalUntaxedPrice"-->
<!--                                        label="未税总价(元)"-->
<!--                                        width="120"-->
<!--                                        align="center">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{'￥'+scope.row.totalUntaxedPrice+'元'}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column prop="totalPrice" label="含税总价(元)"-->
<!--                                                 width="120" align="center">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        {{'￥'+scope.row.totalPrice+'元'}}-->
<!--                                    </template>-->
<!--                                </el-table-column>-->

<!--&gt;-->


<!--                            </el-table>-->
<!--                            <el-table  v-bind:key="item.name+'_o'"-->
<!--                                       :data="item.order" class="el-table-o"-->
<!--                                       size="mini" border :cell-style="columnStyle"-->
<!--                                       style="width: 100%;font-size: 14px" :show-header="false">-->
<!--                                <el-table-column prop="name" align="center" min-width="20%"></el-table-column>-->
<!--                                <el-table-column prop="nameValue" style="width: 80%"></el-table-column>-->


<!--                            </el-table>-->
<!--                        </template>-->


<!--                    </div>-->
<!--                    <div><span style="font-size: 12px">说明：本合同金额不包括现场服务费及安装费用，合同中明确包含“现场服务费”除外。</span></div>-->
<!--                    <div style="margin-top: 16px;font-size: 12px"><span>2. 开票资料信息</span></div>-->
<!--                    <el-table class="el-table-o"-->
<!--                            :data="invoiceData"-->
<!--                            size="mini" border :cell-style="columnStyle"-->
<!--                            :show-header="false" style="width: 100%;font-size: 14px"-->
<!--                    >-->
<!--                        <el-table-column prop="label1" align="center" min-width="20%"></el-table-column>-->
<!--                        <el-table-column prop="v1" min-width="30%"></el-table-column>-->
<!--                        <el-table-column prop="label2" align="center" min-width="20%"></el-table-column>-->
<!--                        <el-table-column prop="v2" min-width="30%"></el-table-column>-->

<!--                    </el-table>-->
<!--                    <div style="margin-top: 16px;font-size: 12px"><span>3. 邮寄信息</span></div>-->
<!--                    <el-table class="el-table-o"-->
<!--                            :data="deliverData" :cell-style="columnStyle"-->
<!--                            size="mini" border :show-header="false" style="font-size: 14px">-->

<!--                        <el-table-column prop="label1" align="center" width="150px" :style="{fontWeight:400}"></el-table-column>-->
<!--                        <el-table-column prop="v1" min-width="30%"></el-table-column>-->
<!--                        <el-table-column prop="label2" align="center" width="150px"></el-table-column>-->
<!--                        <el-table-column prop="v2" min-width="30%"></el-table-column>-->

<!--                    </el-table>-->


<!--                    <div style="font-size: 12px">-->
<!--                        <div>备注：</div>-->
<!--                        <div>1.在中华人民共和国境内，对于净值超过人民币300元的订单我们提供免费寄送服务。对于订货金额低于人民币300元的订单，我们将收取每单40元的送货费。</div>-->
<!--                        <div>2.对于错订的物品，我们将收取10%的退货费，最少100元起。</div>-->
<!--                        <div>3.货物运输至中国境内客户指定地点。</div>-->
<!--                        <div>4.新疆、西藏、青海等偏远地区的最小订单金额、运费及货期以实际报价阶段为准。</div>-->
<!--                    </div>-->
                </div>

        </main>

    </div>
</template>

<script>

    import html2canvas from "html2canvas";
    import printJS from "print-js";

    export default {
        data() {
            return {
                child:{

                    settlementNo:"",
                     totalPrice:"",
                     createTime:"",
                    code:"",
                    companyName:"",
                    id:"",
                    from:""
                },
                loading: false,
                loading1: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                reviewVisible:false,
                reviewForm: {
                    name:"",//收货人
                    pass:true,
                    reason: "",
                    workflowId:"",
                    step:"",
                    orderId:"",
                    totalPrice:""
                },
                infoData:{},
                invoiceData: [],//发票信息
                deliverData: [],//发票及货物接收信息
                orderData:[],//销售订单
                taxData: [],//含税价格
                proData: [],//产品信息
                allData: []


            }
        },
        props: ["from", "id","settlementNo","totalPrice","code","companyName","createTime"],

        methods: {

            info() {
                this.orderData = [{name: "客户编号：",nameValue: this.child.code},
                    {name: "客户名称：",nameValue: this.child.companyName},
                    {name: "结算单号：",nameValue: this.child.settlementNo},
                    {name: "开票金额：",nameValue: '￥'+this.child.totalPrice+'元'}];
                const url = "/admin/invoice/settlementInfo";
                if(this.child.id) {
                    //this.loading1 = true;
                    let _this = this;
                    this.$axios.post(url,{id:this.child.id}).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            _this.loading1 = false;
                            _this.infoData = resp.data;
                            //_this.proData = _this.infoData.orderDetails;

                            let arr = _this.infoData.orderDetails;
                            let orders = _this.infoData.orders;
                            if(arr!= null){

                                for(var key in arr){
                                    var value = arr[ key ]; //注意是 [ ]
                                    //_this.proData = value;

                                    let newData = [{name: "商品未税总价(CNY)：",nameValue: "￥"+orders[key].totalUntaxedPrice+"元"},
                                       {name: "商品含税总价(CNY)：",nameValue: "￥"+orders[key].totalPrice+"元"}];
                                    _this.allData.push({name:key,data:value,order:newData,totalPrice:orders[key].totalPrice,
                                        totalUntaxedPrice:orders[key].totalUntaxedPrice});
                                }
                                // let keys = Object.keys(arr);
                                // alert(keys[0]);
                                // _this.proData = arr.get(keys[0]);
                            }


                            //
                            // _this.taxData = [{name: "商品未税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalUntaxedPrice+"元"},
                            //     {name: "商品含税总价(CNY)：",nameValue: "￥"+_this.infoData.order.totalPrice+"元"}];

                            let invoice =
                                {
                                    label1: "公司名称：",
                                    v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.companyName,
                                    label2: "发票类型：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.showType,

                                }
                            let invoice2 =
                                {
                                    label1: "开户银行：",
                                    v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankName,
                                    label2: "注册电话：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredTel,

                                }
                            let invoice3 =
                                {
                                    label1: "银行账号：",
                                    v1: _this.infoData.invoice==null?'-':_this.infoData.invoice.bankAccount,
                                    label2: "注册地址：",
                                    v2: _this.infoData.invoice==null?'-':_this.infoData.invoice.registeredAddress,

                                }
                            let invoice4 =
                                {
                                    label1: "公司税号：",
                                    v1:  _this.infoData.invoice==null?'-':_this.infoData.invoice.companyTaxNo,
                                    label2: "备注信息：",
                                    v2: '-',

                                }
                            let d2 = [invoice,invoice2,invoice3,invoice4];

                            _this.invoiceData = d2;

                            let invoice5 =
                                {
                                    label1: "邮寄地址：",
                                    v1:  _this.infoData.address.province+ _this.infoData.address.city + _this.infoData.address.county + _this.infoData.address.address,
                                    label2: "详细地址：",
                                    v2:  _this.infoData.address.address,


                                }
                            let invoice6 =
                                {
                                    label1: "收件人：",
                                    v1:  _this.infoData.address.consignee,
                                    label2: "联系电话：",
                                    v2:  _this.infoData.address.mobile,

                                }
                            _this.deliverData = [invoice5,invoice6];

                        }
                    }).catch(function() {
                    });
                }
            },

            goBack() {
                this.$router.go(-1);
            },
            passIt(orderId,step,workflowId,name,totalPrice){

                this.reviewForm.pass = 'true';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;

                if(this.reviewForm.step == undefined) {
                    this.reviewForm.step = step;

                    this.reviewForm.workflowId = workflowId;

                }


                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.addProcess();
            },
            showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
                this.reviewForm.pass = 'false';
                this.reviewForm.reason = '';
                this.reviewForm.orderId = orderId;

                if(this.reviewForm.step == undefined) {
                    this.reviewForm.step = step;
                    this.reviewForm.workflowId = workflowId;

                }

                this.reviewForm.name = name;
                this.reviewForm.totalPrice = totalPrice;
                this.reviewVisible = true;

            },
            addProcess() {//添加审核过程

                const that = this;
                let cond = {...this.reviewForm};

                let optate = "通过";
                optate = cond.pass == 'false' ? "驳回" : "通过";
                this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {

                    cond.pass = cond.pass == 'true' ? true : false;
                    if (cond.pass) {
                        cond.reason = '';
                    }
                    cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                        ,workflowId:cond.workflowId};
                    this.$axios.post("/admin/rfq/review", cond)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {

                                that.reviewVisible = false;
                                that.getStep(that.reviewForm.orderId);
                                if (resp.data == true) {//审核完毕
                                    that.changeOrder(that.reviewForm.orderId);
                                    that.info()();
                                } else {
                                    that.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    that.info()();
                                }


                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                });

            },
            changeOrder(orderId) {//修改状态为下单
                const that = this;
                this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            if(resp.data == true){//审核完毕
                                that.$notify({
                                    title: '成功',
                                    message: '已下单',
                                    type: 'success'
                                });


                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },
            getStep(orderId) {//获得新的审核步骤
                const that = this;
                this.$axios.post("/admin/rfq/getStep", {orderId:orderId,
                    step:this.reviewForm.step,workflowId:this.reviewForm.workflowId})
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            if( resp.data.review){
                                that.reviewForm.step = resp.data.step;
                                that.reviewForm.workflowId = resp.data.workflowId;
                                that.showBtn = true;

                            }else {
                                that.showBtn = false;
                            }


                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            },


            hiddenHeaderRow({ rowIndex }) {
                if (rowIndex == 1) {
                    //隐藏第二行
                    return "hiddenClass";
                }
            },
            hiddenHeaderRow0({ rowIndex }) {
                if (rowIndex > 0) {
                    //隐藏第二行
                    return "hiddenClass";
                }
            },
            // 合并客户基本信息表格客户名称单元格
            arraySpanMethod1({ rowIndex, columnIndex }) {
                if (rowIndex == 0) {
                    if (columnIndex != 0) {
                        return [1, 2];
                    }
                }
            },
            tableHeaderColor ({ rowIndex, columnIndex }) {
                if (rowIndex === 0 && columnIndex === 0) {
                    return { background:'#dfdfdf',fontSize:'14px',color:'black'}
                } else if (rowIndex === 0 && columnIndex !== 0) {
                    return { background: '#dfdfdf', border: '1',color:'black'}
                } else {
                    return { background: '#dfdfdf'}
                }
            },
            //columnStyle( {row, column, rowIndex, columnIndex}) {
            columnStyle( { columnIndex}) {

                //第一三列
                if (columnIndex == 0 || columnIndex == 2) {
                    //字体颜色
                    return {background:'#dfdfdf',fontWeight:'bold',color:'black'};
                }
                return {fontSize:'14px',color:'black'};

            },
            columnStyleO() {
                return {fontSize:'14px',color:'black'};

            },
            orderIt(orderId,name,totalPrice) {//把订单状态从预下单改为下单

                //确定通过abc提交的总价￥123,456,78的订单吗?
                const that = this;
                this.$confirm('确定通过'  +'【' +name+'】提交的总价【￥'+totalPrice+'】的订单吗？', '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {

                    this.$axios.post("/admin/rfq/orderIt", orderId)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {

                                if (resp.data == true) {//
                                    that.$notify({
                                        title: '成功',
                                        message: '已下单',
                                        type: 'success'
                                    });
                                    that.showBtn = false;
                                    that.info();
                                } else {
                                    that.$notify({
                                        title: '提示',
                                        message: '下单失败',
                                        type: 'success'
                                    });

                                }

                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                });


            },
            printOrder(){
                this.$bus.$emit('menuClose',true);
                html2canvas(this.$refs.p, {
                    width: this.$refs.p.clientWidth+20,
                    height: this.$refs.p.clientHeight,
                }).then((canvas) => {
                    const url = canvas.toDataURL();
                    printJS({
                        printable: url,
                        type: 'image',
                        documentTitle: '打印图片',
                        maxWidth: 9999,
                        style: `@media print { @page {size: auto; margin: 20px; } body{margin:0}}`
                    });
                });



            },

        },
        mounted(){

        },
        created() {
            let paramsStore;
            const params = sessionStorage.getItem("params");
            if(params) {
                paramsStore = JSON.parse(params);
            }
            const { createTime,totalPrice,settlementNo,code,companyName,id,from } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
            this.child.settlementNo = settlementNo;
            this.child.totalPrice = totalPrice;
            this.child.createTime = createTime;
            this.child.code = code;
            this.child.companyName = companyName;
            this.child.id = id;
            this.child.from = from;
            this.info();

        },

    }
</script>
<style lang="scss" scoped>
    .hiddenClass {
        display: none !important;
    }
    .el-table-order{
        max-width: 551px !important;
        width: 551px !important;
        margin-right: 10px;
    }
    ::v-deep .tableBaseInfo {
        .hiddenClass {
            display: none !important;
        }

    }

    ::v-deep .el-table th {
        border-color: black !important;

    }
    ::v-deep .el-table td {
        border-color: black !important;

    }
    ::v-deep .el-table--group,
    ::v-deep .el-table--border {
        border: 0.5px solid black !important;
    }
    ::v-deep .no-header-only.el-table--border {
        border-top: 0.5px solid black !important;
    }
    ::v-deep .no-header.el-table--border {
        border-top: 0.5px solid black !important;
    }
    /*.el-table-o{*/
    /*    max-width: 1100px !important;*/
    /*    width: 1100px !important;*/
    /*    margin-right: 0px;*/
    /*}*/
    .el-table-o{

        margin-right: 0px;
    }

    .quote {
        min-width: 1200px;
        margin: 0 auto;
        background-color: white;
    }
    .quote table {
        border-collapse: collapse;
    }
    .quote .thead .th {
        height: 38px;
        line-height: 38px;
        text-align: center;
        font-weight: bold;
        color: #333;
        font-size: 16px;
        border-right: 1px solid #AED8FF  !important;
        display: inline-block;
    }
    .pt10{
        padding: 10px;
    }

</style>